export default {
  amp: 'ap',
  catDomainName: 'do',
  clientInformation: 'ci',
  clientDays: 'cy',
  clientState: 'cs',
  code: 'cp',
  comment: 'co',
  cryptoLibrary: 'cl',
  dailyClients: 'cd',
  deviceInformation: 'di',
  detected: 'dt',
  errors: 'er',
  event: 'ev',
  eventTime: 'et',
  firstEvent: 'fi',
  flagPiBurst: 'fb',
  flagPiFrequency: 'ff',
  flagPiReload: 're',
  flagViewTime: 'fv',
  flags: 'fl',
  geoLocation: 'lo',
  hourlyClients: 'ch',
  hourlyWnk: 'nk',
  hybrid: 'hy',
  language: 'lg',
  lastChecksum: 'bc',
  lastCode: 'lc',
  lastEvent: 'le',
  lastSite: 'ls',
  lastTransaction: 'la',
  localData: 'ld',
  lastViewtime: 'lv',
  localTime: 'lt',
  loyalty: 'll',
  measuredData: 'md',
  message: 'ms',
  monthlyClients: 'cm',
  panelDomainName: 'dp',
  pi: 'pi',
  pixelType: 'pt',
  platform: 'pl',
  profile: 'pr',
  privacySetting: 'ps',
  refererHost: 'rf',
  runtime: 'rt',
  savedAt: 'ct',
  screenResolution: 'xy',
  scriptType: 'vy',
  scriptVersion: 'vr',
  clientSchemaVersion: 'cv',
  sequenceNumber: 'sn',
  sessionStart: 'ss',
  site: 'st',
  serviceDomainName: 'dn',
  siteHash: 'sh',
  siteInformation: 'si',
  storage: 'sg',
  surveyStatus: 'sv',
  technicalInformation: 'ti',
  timeZone: 'tz',
  transmissionError: 'te',
  type: 'tp',
  urlCache: 'uc',
  urlHost: 'ur',
  userAgentString: 'ua',
  viewtime: 'vt',
  visits: 'vi',
  weeklyClients: 'cw',
};
